import { useMutation } from "@apollo/client";
import gql from "graphql-tag";
import React from "react";
import { useParams } from "react-router";
import ReactDocumentTitle from "../../../components/ReactDocumentTitle";
import CompanyEditManagerForm from "../../../components/company/CompanyEditManagerForm";
import FormWrapper from "../../../components/licenseType/FormWrapper";
import AppLayout from "../../../layouts/AppLayout";
import { CompanyManagerInput } from "../../../schema";
import BackLink from "../../../ui/BackLink";
import FormTitle from "../../../ui/FormTitle";
import { reverse } from "../../../urls";
import { handleError, handleSuccess } from "../../../utils/Apollo";

interface QueryParams {
  id: string;
  managerId: string;
}

export default function BrandEditCompanyScene() {
  const { managerId, id } = useParams<QueryParams>();
  const [submit] = useMutation(mutation);
  const link = reverse("licensee_profile", { id: `cmp_${id}` });
  const backLink = `${link}/managers`;

  const onFormSubmit = React.useCallback(
    (formData) => {
      const data: CompanyManagerInput = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        companyId: id,
      };
      console.log(data, managerId);
      submit({
        variables: { id: managerId, data },
      }).then(
        () => handleSuccess("Manager updated", backLink),
        (apolloError) => handleError(apolloError)
      );
    },
    [submit]
  );

  return (
    <>
      <ReactDocumentTitle title="Edit manager" />
      <AppLayout className="bg-gray-light">
        <BackLink backLink={backLink} title="Back to profile" />
        <FormTitle>Edit manager</FormTitle>
        <FormWrapper>
          <CompanyEditManagerForm
            backLink={backLink}
            onSubmit={onFormSubmit}
            managerId={managerId}
            companyId={id}
          />
        </FormWrapper>
      </AppLayout>
    </>
  );
}
const mutation = gql`
  mutation EditFormMutation($id: ID!, $data: CompanyManagerInput!) {
    updateCompanyManager(id: $id, data: $data) {
      id
      firstName
      lastName
      email
    }
  }
`;
